import { DivMarginTop } from "components/common/style/margin/DivMarginTop";
import { Button } from "@mui/material";
import { useContainCountUpdateAll } from "hooks/asocijator/character/useContainCountUpdateAll";

const RelateContainAction = () => {
  const { containCountUpdateAllMutate } = useContainCountUpdateAll();
  const containCountUpdateHandle = () => {
    containCountUpdateAllMutate();
  };

  return (
    <>
      <DivMarginTop mt={0}>
        Relate contain count for all characters of type radical or character set
      </DivMarginTop>
      <DivMarginTop mt={1}>
        <Button variant="outlined" onClick={containCountUpdateHandle}>
          OK
        </Button>
      </DivMarginTop>
    </>
  );
};

export default RelateContainAction;
